<template>
    <section>
        <div class="contBox">

            <h3>Añadir Cliente</h3>
            <form action="">

                <div>
                    <label for="paqName">Nombre</label>
                    <input v-model="nombre" placeholder="Elige un nombre" minlength="6" required id="paqName" type="text">
                </div>
                <div>
                    <label for="paqName">Paquete</label>
                    <div :class="{ valid: id_paquete !== '' }" @click="paqueteSelector = !paqueteSelector"
                        class="selector">
                        <p :class="{ filled: id_paquete !== '' }">{{ id_paquete === '' ? 'Elige un paquete' : nombrePaquete }}</p>
                        <img src="../../assets/blueflecha.svg" alt="">
                        <div v-if="paqueteSelector" class="selectorOptions">

                            <ul>
                                <li v-for="(paquete, index) in pqts" :key = "index" @click="id_paquete = paquete.id, nombrePaquete = paquete.nombre">
                                    {{ paquete.nombre }}
                                </li>
                            </ul>

                        </div>
                    </div>
                </div>
                <div>
                    <label for="paqName">Status</label>
                    <div :class="{ valid: estatus !== '' }" @click="showSelector = !showSelector" class="selector">
                        <p :class="{ filled: estatus !== '' }">{{ estatus === '' ? 'Elige un status' : estatus | splitUp }}</p>
                        <img src="../../assets/blueflecha.svg" alt="">
                        <div v-if="showSelector" class="selectorOptions">

                            <ul>
                                <li @click="estatus = 'activo'">
                                    Activo
                                </li>
                                <li @click="estatus = 'pendiente'">
                                    Pendiente
                                </li>
                                <li @click="estatus = 'vencido'">
                                    Vencido
                                </li>
                            </ul>

                        </div>
                    </div>
                </div>
                <div>
                    <label for="paqBandW">Correo</label>
                    <input v-model="correo" min="0" required id="paqBandW" type="email" placeholder="expample@email.com">
                </div>
                <div>
                    <label for="cliPass">Contraseña</label>
                    <input v-model="pass" type="password" id="" min="6" required>
                </div>
            </form>

            <div class="action">
                <button class="outline" @click="wait">
                    <p>Cancelar </p> <img src="../../assets/SubtractFill.svg" alt="">
                </button>
                <button @click="addCli(nombre, id_paquete, estatus, correo, pass)" class="pink">
                    <p>Añadir Cliente </p> <img src="../../assets/Subtract.svg" alt="">
                </button>
            </div>
            <div v-if="status !=='' && message" class="status_messages">
                <div  v-if="status ==='error'" class="msg msg_error">
                    <p>{{message}}</p>
                </div>
            </div>
        </div>
        <div v-if="viewModal" class="modal_view">
            <div id="modal_add">
               <div class="body dflx">
                          <h3>Cliente agregado</h3>
                          <img src="../../assets/add.png" alt="icono alerta">
               </div>
           <div class="modal_add_btns dflx">
               <p @click="Add()" class="otro">Aceptar</p> <p  @click="toEdit()" class="editar">Editar</p>  <p  @click="wait()" class="inicio">Inicio</p>
           </div>
         </div>
        </div>
    </section>
</template>

<script>
import { mapActions } from 'vuex';
import addCliente from './addCliente.vue'
import editCliente from './editCliente.vue'
export default {
    name: 'AñadirClient',
    components: {
        addCliente,
        editCliente,
    },
    data() {
        return {
            showSelector: false,
            paqueteSelector: false,
            nombrePaquete: '',
            nombre: '',
            estatus: '',
            correo: '',
            id_paquete: '',
            viewModal: false,
            message: '',
            status: '',
            pass: '',
        }
    },
    async created(){
        const response = await this.getAllInfoPqt('paquete');
    },
    computed: {
        pqts(){
            let data = this.$store.getters["paquete/data"]
            if(!Array.isArray(data)) return []
            data.push({id: 0, nombre: "Sin paquete"})
            return data;
        },

    },
    methods: {
        ...mapActions('servidores', ['setHistoryOptionSrv']),
        ...mapActions('clients', ['setAddedCli', 'setHistoryOptionCli']),
        ...mapActions("paquete", ['getAllInfoPqt']),


        wait: function () {
            setTimeout(() => this.$router.go(), 200);
        },
        validatePassword: function (password) {
            const regex = /^(?=.*[A-Z])(?=.*\d).+$/;
            return regex.test(password);
        },

        addCli: async function(nombre, id_paquete, estatus, correo, pass ){
            
            if (!this.validatePassword(this.pass)) {
                this.status = 'error';
                this.message = 'La contraseña debe tener al menos una letra mayúscula y un número.';
                this.delStatus();
                return;
            }

            this.status =''
            this.message =''

            const result = await this.$store.dispatch("clients/addItemCli",  {option:'clients', item: { nombre, id_paquete, estatus, correo, pass } });

            if(!result?.added){
                    this.status='error'
                    this.message= "Ha ocurrido un error"
                    this.delStatus()
                }else{
                    this.setAddedCli(result.added )
                    this.viewModal=true
                }
        },
        delStatus: function () {
            setTimeout(() => {
                  this.status =''
                 this.message =''
            }
            ,2000);
        },
        Add(){
            this.nombre="";
            this.estatus=""; 
            this.id_paquete=""; 
            this.correo=""; 
            this.nombrePaquete="";
            this.viewModal=false;
            this.message="";
            this.status= '';
            this.pass="";
        },

        toEdit:function(){
            this.setHistoryOptionCli('editClient')
            this.viewModal=false;
        },  
    },
        filters: {
        splitUp: (value) => {
            if (value.length === 0) {
            return value;
        }
        return value.charAt(0).toUpperCase() + value.slice(1);
            },
        },

}
</script>


<style scoped>
* {
    margin: 0;
    padding: 0;
}

h3 {
    color: #acacac;

    font-size: 1.2375VW;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
}

.contBox {
    display: flex;
    padding: 1.7187500000000002VW 1.9791666666666665VW;
    flex-direction: column;
    gap: 1.2VW;
    border-radius: 1.25VW;
    border: 0.5px solid #E6E6E6;
    background: #FFF;
}


.action {
    display: flex;
    flex-direction: row;
    gap: 1vw;
}

.action button {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    width: 12vw;
    padding: 0.7vw 1.2vw;
    border-radius: 50vw;
    border: none;
    cursor: pointer;
}

.action button p {

    font-size: 0.725VW;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
}

.pink {
    background: var(--color-1);
    color: #FFF;

}

.outline {
    border: solid 0.1vw var(--color-4) !important;
    background: transparent;
    color: var(--color-1);
}

form {
    width: 50vw;
    display: flex;
    flex-wrap: wrap;
    gap: 0.8vw 2vw;
}

form>div {
    width: 19.416666666666668VW;
    display: flex;
    flex-direction: column;
    gap: 0.5vw;
}

form>div label {
    color: #7948FF;

    font-family: var(--Poppins);
    font-size: 0.825VW;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

form>div input {
    font-weight: 500;
    font-family: var(--Poppins);
    padding: 0.7166666666666667VW 0.825VW;
    font-size: 0.7208333333333333VW;
    border-radius: 0;
    border: solid #b8b8b8 0.1vw;
    transition: 300ms all;
}

input:focus {
    border-color: #7948FF;
}

input:valid {
    border-color: greenyellow;
}

input:invalid {
    border-color: #b8b8b8;
}

input::placeholder {
    color: #cfcfcf;
}

.selector {
    position: relative;
    font-weight: 500;
    font-family: var(--Poppins);
    padding: 0.7166666666666667VW 0.825VW;
    font-size: 0.7208333333333333VW;
    border-radius: 0;
    border: solid #b8b8b8 0.1vw;
    transition: 300ms all;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;
}

.selector p {
    user-select: none;
    color: #cfcfcf;
}

.selector img {
    width: 1vw;
}

.inputValueSymbol {
    width: 22.216667VW;
}

.inputValueSymbol input {
    width: 17.716666666666668VW;

}

.inputValueSymbol span {
    width: 20%;
    color: #acacac;
    font-size: 0.7vw;
}

.selectorOptions {
    position: absolute;
    width: 100%;
    background-color: rgb(255, 255, 255);
    border: solid #b8b8b8 0.1vw;
    border-top: none;
    margin-left: -0.87vw;
    height: auto;
    top: 0;
    transform: translateY(2.5vw);
}

li {
    font-weight: 500;
    font-family: var(--Poppins);
    padding: 0.7166666666666667VW 0.825VW;
    font-size: 0.7208333333333333VW;
    border-radius: 0;
    transition: 300ms all;
    list-style: none;
}

li:hover {
    background-color: #f3f3f3;
}

.filled {
    color: #000000 !important;
    font-weight: 900;
}

.valid {
    border-color: greenyellow;
}
</style>